export default "__VITE_ASSET__CHWv3CdE__"